export const ACCESS_MODULES = [
	"agents",
	"suggestions",
	"missions",
	"memory",
	"site",
	"structure",
	"system",
	"automation",
	"reports",
	"files",
	"workspace",
	"billing",
] as const;
export type AccessModule = (typeof ACCESS_MODULES)[number];
export const MODULE_GROUPS = [
	{ key: "ia", modules: ["agents", "suggestions", "missions", "memory"] },
	{ key: "construir", modules: ["site", "structure", "system", "automation", "reports"] },
	{ key: "workspace", modules: ["files", "workspace", "billing"] },
] as const;

export function moduleForPath(address: string): AccessModule | undefined {
	const [path, query] = address.split("?");
	if (path === "/settings") {
		const tab = new URLSearchParams(query).get("aba");
		return tab && tab !== "conta" ? "workspace" : undefined;
	}
	const root = path?.split("/")[1];
	if (root === "r") return "reports";
	if (root === "channels") return "workspace";
	if (ACCESS_MODULES.includes(root as AccessModule)) return root as AccessModule;
	return undefined;
}

export function moduleAllowed(address: string, disabled: readonly AccessModule[] = []): boolean {
	const module = moduleForPath(address);
	return !module || !disabled.includes(module);
}
